module.exports = __webpack_public_path__ + "static/media/co.49335984.svg";